function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import constants from '../constants/annotationSelectionConstants';
import formActionCreators from './formActionCreators';
import reportAnnotationActionCreators from './reportAnnotationActionCreators';
import { legacyRectStringToFormRect, pathStringToPointArray } from '../utils/transformFormAnnotation';
const clearSelection = () => async (dispatch, getState) => {
  const {
    annotationContext
  } = getState().annotationSelection;
  dispatch({
    type: constants.CLEAR_SELECTION,
    annotationContext // will be used in reportAnnotationReducer and annotationReducer
  });
};
const select = annotation => async (dispatch, getState) => {
  const {
    annotationContext
  } = getState().annotationSelection;
  dispatch({
    type: constants.SELECT,
    payload: annotation,
    annotationContext // will be used in reportAnnotationReducer and annotationReducer
  });
};
const setAnnotationContext = context => ({
  type: constants.SET_ANNOTATION_CONTEXT,
  payload: context
});
const setDefaultColor = color => ({
  type: constants.SET_DEFAULT_COLOR,
  payload: color
});
const setClickedEntity = clickedEntity => ({
  type: constants.SET_CLICKED_ENTITY,
  clickedEntity
});
const setSelectableType = (type, canEdit = false) => ({
  type: constants.SET_SELECTABLE_TYPE,
  payload: {
    type,
    canEdit
  }
});
const trackCursor = (point, rotation, pageNumber) => ({
  type: constants.TRACK_CURSOR,
  pageNumber,
  rotation,
  point
});
const trackReset = () => ({
  type: constants.TRACK_RESET
});
const startDrawing = () => ({
  type: constants.START_DRAWING
});
const batchChange = changesArray => async (dispatch, getState) => {
  const {
    annotationContext
  } = getState().annotationSelection;
  if (annotationContext === 'report') {
    for (let i = 0; i < changesArray.length; i += 1) {
      const change = changesArray[i];
      // eslint-disable-next-line no-await-in-loop
      await dispatch(reportAnnotationActionCreators.change(change.id, change.path, change.data));
    }
    return;
  }
  if (annotationContext === 'form') {
    // Transform legacy changes to form changes
    const transformed = changesArray.map(change => {
      if (change.path === 'rectString') {
        return _objectSpread(_objectSpread({}, change), {}, {
          path: '/content/render/rect',
          data: legacyRectStringToFormRect(change.data)
        });
      }
      if (change.path === 'inkAnnotation/pathString') {
        return _objectSpread(_objectSpread({}, change), {}, {
          path: '/content/render/pointArray',
          data: pathStringToPointArray(change.data)
        });
      }
      return change;
    });

    // make batch change, the form reducer will update the form and the
    // annotation reducer will handle syncing with display state
    await dispatch(formActionCreators.batchChange(transformed));
    return;
  }
  throw new Error(`Unknown annotationContext: ${annotationContext}`);
};
export default {
  select,
  clearSelection,
  setAnnotationContext,
  setClickedEntity,
  setDefaultColor,
  setSelectableType,
  startDrawing,
  trackReset,
  trackCursor,
  batchChange
};